import { Component, Input } from '@angular/core';

@Component({
  selector: 'dark-pool-title',
  template: require('./dark-pool-title.html')
})
export class DarkPoolTitleComponent {
  @Input() currentOrg;
}
